import Hex from 'crypto-js/enc-hex'
import hmacSha256 from 'crypto-js/hmac-sha256'
import encSha256 from 'crypto-js/sha256'
import SparkMD5 from 'spark-md5'
type Encoder = 'hex' | 'buffer'

/** CryptoJS WordArray — an object with `words` (Int32Array) and `sigBytes` properties */
interface WordArray {
  words: number[]
  sigBytes: number
  toString(encoder?: any): string
}

export const sha256 = (data: any): string => {
  const result = Hex.stringify(encSha256(data))
  return result
}
export const md5 = (data: any): string => {
  // TODO: cause some stutters as it has to calc hash in the main thread,
  // use wasm if possible?
  const md5 = SparkMD5.ArrayBuffer.hash(data, true)
  const result = btoa(md5)
  return result
}
export function hmac(signingKey: any, data: string): WordArray
export function hmac(signingKey: any, data: string, encoder: 'hex'): string
export function hmac(
  signingKey: any,
  data: string,
  encoder: 'buffer',
): WordArray
export function hmac(
  signingKey: any,
  data: string,
  encoder?: Encoder,
): string | WordArray {
  const result = hmacSha256(data, signingKey)
  if (encoder === 'hex') return Hex.stringify(result)
  // 'buffer' or undefined: return the raw WordArray for HMAC chaining (e.g., AWS Signature V4)
  return result
}
